/**
 * Application Configuration
 * Centralized storage of configuration constants
 */

// Compute WebSocket URL dynamically if not provided in env
const getWsBaseUrl = () => {
  const envWsUrl = import.meta.env.VITE_WS_BASE_URL
  if (envWsUrl) return envWsUrl

  // If not specified (like in production with relative API paths),
  // calculate based on current browser location
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${window.location.host}`
}

// API Configuration
export const API_CONFIG = {
  // Base URL of the API (from environment variables)
  BASE_URL: import.meta.env.VITE_API_BASE_URL,
  // WebSocket Base URL (from environment variables or computed dynamically)
  WS_BASE_URL: getWsBaseUrl(),
  // Timeout for API requests (in milliseconds)
  TIMEOUT: 30000,
  // WebSocket timeout (in milliseconds)
  WS_TIMEOUT: 10000,
}

// Application Configuration
export const APP_CONFIG = {
  // Application Name
  NAME: 'UDACAPI Admin',
  // Application Version
  VERSION: '1.0.0',
  // Default Locale
  DEFAULT_LOCALE: 'en',
}

// Feature Flags
export const FEATURE_FLAGS = {
  // Permission Groups feature
  PERMISSION_GROUPS: import.meta.env.VITE_FEATURE_PERMISSION_GROUPS === 'true',
  // WebSocket feature
  WEBSOCKET_ENABLED: import.meta.env.VITE_WS_ENABLED === 'true',
  // WebSocket fallback to polling
  WEBSOCKET_FALLBACK_POLLING: import.meta.env.VITE_WS_FALLBACK_POLLING === 'true',
}

export default {
  API: API_CONFIG,
  APP: APP_CONFIG,
  FEATURE_FLAGS,
}
